import React from 'react';

import { block } from 'bem-cn';

import './icon-button.scss';

const b = block('icon-button');

type IconButtonPropsType = {
  icon: any;
  onClick: () => void;
};

const IconButton = ({ icon, onClick }: IconButtonPropsType) => (
  <div className={b()} onClick={onClick}>
    <div className={b('icon-wrapper')}>
      <img src={icon} alt='icon' />
    </div>
  </div>
);

export default IconButton;
